import PageWrapper from "../components/animations/PageWrapper";
import AnimatedCard from "../components/ui/AnimatedCard";
import CardHeader from "../components/ui/CardHeader";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Formations() {
  return (
    <main className="page-content">
      <PageWrapper>
        <section id="formations">
          <Link to="/accueil" className="back-link" aria-label="Retour à l'accueil">
            <ArrowLeft size={18} />
            <span>Accueil</span>
          </Link>
          <h2>Formations</h2>
          {[
            {
              titre: "Ulsan National Institute of Science and Technology (UNIST)",
              date: "Sep. — Déc. 2025",
              type: "CSE - Computer Science and Engineering",
              description: "Formation en échange universitaire dans la ville d'Ulsan en Corée du Sud. Spécialisation en Meta et Multi-task Learning, et  en Sécurité Informatique.\nLangue d'enseignement : Anglais."
            },
            {
              titre: "INSA de Rouen Normandie",
              date: "2021 — aujourd'hui",
              type: "ITI - Informatique et Technologie de l'Information",
              description: "Formation en informatique. Spécialisation dans le Machine Learning, l'IA, le développement logiciel et la Data Science.\nPianiste à l'orchestre de l'INSA."
            },
            {
              titre: "Lycée Blaise Pascal",
              date: "2018 — 2021",
              type: "Spécialités : Mathématiques, Physique Chimie et Numérique et Science de l'Informatique",
              description: "Baccalauréat mention Très Bien.\nProjet écologique de mise en place d'un potager au sein du lycée en équipe."
            }
          ].map((formation, index) => (
            <AnimatedCard key={index}>
              <CardHeader
                title={formation.titre}
                subtitle={formation.type}
                meta={formation.date}
              />
              {formation.description.split('\n').map((line, i) => (
                <p key={i}>{line}</p>
              ))}
            </AnimatedCard>
          ))}
        </section>
      </PageWrapper>
    </main>
  );
}
